var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleTypeTaxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taxi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,16H24.24L19.89,10.2A2.13,2.13,0,0,0,18,9H12V8h1.1A1.9,1.9,0,0,0,15,6.1V4.9A1.9,1.9,0,0,0,13.1,3H8.9A1.9,1.9,0,0,0,7,4.9V6.1A1.9,1.9,0,0,0,8.9,8H10V9H5.85a2.13,2.13,0,0,0-2,1.54l-.62,2.16a1,1,0,1,0,1.92.54l.62-2.15A.12.12,0,0,1,5.85,11H13v5H3a1,1,0,0,0-1,1v5.78A2.2,2.2,0,0,0,4.05,25a4.2,4.2,0,0,0,0,.51,3.5,3.5,0,0,0,7,0A4,4,0,0,0,11,25h9.92a3.53,3.53,0,0,0,.25,1.63A3.47,3.47,0,0,0,23,28.51a3.61,3.61,0,0,0,1.32.26,3.35,3.35,0,0,0,1.36-.28A3.49,3.49,0,0,0,27.84,25,2.2,2.2,0,0,0,30,22.81V20A4,4,0,0,0,26,16ZM9,5h4V6H9Zm6,6h3a.12.12,0,0,1,.11.08.82.82,0,0,0,.12.2L21.75,16H15ZM4,18h9v5H10a3.48,3.48,0,0,0-4.9,0H4.19A.19.19,0,0,1,4,22.81Zm3.5,9A1.5,1.5,0,1,1,9,25.5,1.5,1.5,0,0,1,7.5,27ZM28,22.81a.19.19,0,0,1-.19.19H27a1.55,1.55,0,0,0-.21,0,1,1,0,0,0-.82.08,1,1,0,0,0-.34,1.38,1.46,1.46,0,0,1,.1,1.33,1.43,1.43,0,0,1-.8.82,1.48,1.48,0,0,1-1.15,0,1.51,1.51,0,0,1-.82-.81,1.48,1.48,0,0,1,0-1.15,1.45,1.45,0,0,1,1-.88,1,1,0,1,0-.51-1.94A3.54,3.54,0,0,0,21.7,23H15V18H26a2,2,0,0,1,2,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleTypeTaxi);
export default __webpack_public_path__ + "static/media/vehicle-type-taxi.0074e1e79247e354699732e4a4f7efe2.svg";
export { ForwardRef as ReactComponent };